var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_1159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 1C10.125 0.447715 9.62132 0 9 0C8.37868 0 7.875 0.447715 7.875 1L7.875 7.875H1C0.447715 7.875 0 8.37868 0 9C0 9.62132 0.447715 10.125 1 10.125H7.875L7.875 17C7.875 17.5523 8.37868 18 9 18C9.62132 18 10.125 17.5523 10.125 17V10.125H17C17.5523 10.125 18 9.62132 18 9C18 8.37868 17.5523 7.875 17 7.875H10.125V1Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f862b4745580f878e65b16c6044f64dc.svg";
export { ForwardRef as ReactComponent };